const config = {
  DEFAULT_ICON_PATH: 'https://firebasestorage.googleapis.com/v0/b/mike-242702.appspot.com/o/assets%2Fdefault_user_icon.png?alt=media&token=deac4950-99bc-4f5b-ab5a-07bcc8762651',
  COMMISSION_RATE: 0.15
}

export { config }